var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isShow
    ? _c(
        "div",
        { staticClass: "changecon" },
        [
          _c("SectionTitle", { attrs: { title: "修改内容" } }),
          _c(
            "div",
            { staticClass: "changecon-table" },
            [
              _c(
                "el-table",
                {
                  ref: "table",
                  attrs: {
                    border: "",
                    data: _vm.tableData,
                    "header-cell-style": this.$globalGrayTableHeaderStyle,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      label: "修改次数",
                      width: "100",
                      align: "center",
                      type: "index",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "修改内容简述",
                      "show-overflow-tooltip": true,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              (!scope.row.id || scope.row.editable) &&
                              !scope.row.modifyProfile
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "mini" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editClick(
                                            scope.$index,
                                            scope.row.modifyProfile
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("编辑修改简述")]
                                  )
                                : _c("span", [
                                    _vm._v(_vm._s(scope.row.modifyProfile)),
                                  ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1844475365
                    ),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      label: "修改时间",
                      width: "200",
                      align: "center",
                      prop: "modifyTime",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: { label: "修改操作", width: "160", align: "center" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.id && !scope.row.editable
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.historyVersion(scope.row)
                                        },
                                      },
                                    },
                                    [_vm._v("查看历史版本")]
                                  )
                                : scope.row.modifyProfile || scope.row.editable
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.editClick(
                                            scope.$index,
                                            scope.row.modifyProfile
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("修改描述")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1271542031
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.visiter,
                width: "600px",
                title: "修改内容描述",
                "before-close": _vm.cancelClick,
                "modal-append-to-body": false,
                "close-on-click-modal": false,
                "close-on-press-escape": false,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "footer",
                    fn: function () {
                      return [
                        _c(
                          "div",
                          { staticClass: "dialog-btns" },
                          [
                            _c(
                              "el-button",
                              { on: { click: _vm.cancelClick } },
                              [_vm._v("取消")]
                            ),
                            _c(
                              "el-button",
                              {
                                attrs: { type: "primary" },
                                on: { click: _vm.submit },
                              },
                              [_vm._v("确定")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                false,
                1090420941
              ),
            },
            [
              _c("el-input", {
                attrs: {
                  type: "textarea",
                  maxlength: "2000",
                  "show-word-limit": "",
                  autosize: { minRows: 8, maxRows: 8 },
                },
                model: {
                  value: _vm.modifyProfile,
                  callback: function ($$v) {
                    _vm.modifyProfile = $$v
                  },
                  expression: "modifyProfile",
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }